import {AbstractControl} from '@angular/forms';
import {isValidIBAN} from 'ibantools';

export function ValidateIban(control: AbstractControl) {
  if (control.value !== null) {
    const iban = control.value.replace(/\s+/g, '');
    if (!isValidIBAN(iban)) {
      return { validIban: true };
    }
  }
  return null;
}
